import React, { useState } from 'react';
import Slider from 'react-slick';
import { connect } from 'react-redux';
import { setSlikePreviewID } from 'reduxUtils/modules/common';
import makeRequest from 'utils/makeRequest';
import Morebtn from 'components_v2/mobile/Morebtn';
import EtimesMobileTabs from 'components_etimes/common/EtimesMobileTabs/EtimesMobileTabs';
import LoaderSpinner from 'components_v2/common/LoaderSpinner/LoaderSpinner';
import NewStoryCard from 'components_v2/mobile/NewStoryCard';
import SectionHeader from 'components_v2/common/SectionHeader';
import ErrorBoundary from '../../../components/ErrorBoundary/ErrorBoundary';
import PaginationWidget from '../../../routes/newslisting/components/common/PaginationWidget/PaginationWidget';
//import s from '../../layouts/mobile/EtimesListing.scss';
// eslint-disable-next-line no-unused-vars
//import slickcss from '../../../../node_modules/slick-carousel/slick/slick.css';

export const renderStoryCard = (
  story,
  ga4Type,
  shouldNotlazyloadImage,
  hoveredSlikeId,
  hoveredSlikeIndex,
  setSlikePreviewId,
  toiVideoFeedFormat,
  cardType,
) => {
  const setSlikePreview = (msid, gaIndex) => {
    setSlikePreviewId(msid, gaIndex);
  };
  return (
    <ErrorBoundary>
      <NewStoryCard
        title={story?.hl}
        msid={story?.msid || story?.id}
        syn={story?.synopsis}
        imagesize={story?.imagesize}
        isBigHeading={story?.isBigHeading}
        isLarge={story?.isLarge}
        cardType={story?.cardType || story?.tn}
        wu={story?.wu}
        criticRating={story?.criticRating}
        iconClass={story?.iconClass}
        cmstype={story?.cmstype}
        gaIndex={story?.gaIndex}
        ga4Label={story?.ga4Label}
        ga4Type={ga4Type}
        shouldNotlazyloadImage={shouldNotlazyloadImage}
        videoTime={story?.videoTime}
        createdTime={story?.createdTime}
        createdTime2={story?.createdTime2}
        fromToiPrint={story?.fromToiPrint}
        slikeId={story?.slikeId}
        hoveredSlikeId={hoveredSlikeId}
        hoveredSlikeIndex={hoveredSlikeIndex}
        setSlikePreviewId={setSlikePreview}
        key={`${story?.msid}_${story?.gaIndex}`}
        showIIcon={story?.showIIcon}
        showPopup={story?.showPopup}
        des={story?.des}
        tagName={story?.tagName}
        tagColor={story?.tagColor}
        tagBgColor={story?.tagBgColor}
        {...toiVideoFeedFormat && {
          msid: story?.id,
          wu: '',
          title: story?.hl,
          cardType,
          ga4Type,
        }}
        birthdate={story?.birthdate}
        occupation={story?.occupation}
        hobbies={story?.hobbies}
        width={story?.width}
        buttonText={story?.buttonText}
        buttonBgColor={story?.buttonBgColor}
        buttonTextColor={story?.buttonTextColor}
        buttonDisabled={story?.buttonDisabled}
        // lazyloadImg
      />
    </ErrorBoundary>
  );
};

const MobileCardLayout = ({
  section,
  s,
  hoveredSlikeId,
  hoveredSlikeIndex,
  setSlikePreviewId,
  showLoadMoreStories,
  loadMoreCallback,
  loadMoreText,
}) => {
  if (!(section && Array.isArray(section.items))) {
    return null;
  }

  const { pagination, items } = section;

  const settings = {
    dots: true,
    arrows: false,
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
    className: 'center',
  };

  const [isLoading, setIsLoading] = useState(false);
  const [itemsLoaded, setItemsLoaded] = useState([]);
  const [activeTabPath, setActiveTabPath] = useState('');
  const [nextPageUrl, setNextPageUrl] = useState(
    pagination && pagination.nextPageUrl,
  );

  const itemstoRender =
    Array.isArray(itemsLoaded) && itemsLoaded.length > 0 ? itemsLoaded : items;

  const loadSectionData = params => {
    const dataUrl = params && params.clickedItem && params.clickedItem.dataUrl;
    const path = params && params.clickedItem && params.clickedItem.path;
    if (!dataUrl) {
      return;
    }
    setIsLoading(true);
    makeRequest
      .get(dataUrl, { isMobile: true }, 'skipfeedengine')
      .then(response => {
        if (
          response &&
          response.data &&
          ((response.data.items && response.data.items.length > 0) ||
            response.data?.length > 0)
        ) {
          const responseItems =
            Array.isArray(response.data.items) && response.data.items.length > 0
              ? response.data.items
              : response.data;
          setItemsLoaded(responseItems);
          if (path) {
            setActiveTabPath(path);
          }
          setIsLoading(false);
        } else {
          setActiveTabPath(path || section.path);
          setIsLoading(false);
        }
      });
  };

  const loadMoreData = dataUrl => {
    if (!dataUrl) {
      return false;
    }

    setIsLoading(true);

    makeRequest
      .get(dataUrl, { isMobile: true })
      .then(data => {
        if (!(data && data.data && Array.isArray(data.data.items))) {
          setIsLoading(false);
          setNextPageUrl(
            data &&
              data.data &&
              data.data.pagination &&
              data.data.pagination.nextPageUrl,
          );
          return false;
        }
        if (
          Array.isArray(itemstoRender) &&
          itemstoRender.length > 0 &&
          itemstoRender[itemstoRender.length - 1] &&
          Array.isArray(itemstoRender[itemstoRender.length - 1].items)
        ) {
          itemstoRender[itemstoRender.length - 1].items = [
            ...itemstoRender[itemstoRender.length - 1].items.concat(
              data.data.items,
            ),
          ];
        }
        setNextPageUrl(
          data.data.pagination && data.data.pagination.nextPageUrl,
        );
        setIsLoading(false);
        return false;
      })
      .catch(err => {
        console.error(err);
        setIsLoading(false);
      });
    return false;
  };

  return (
    <>
      {!nextPageUrl && isLoading && <LoaderSpinner />}
      {section?.hl && <h2 className={s.mainText}>{section.hl}</h2>}
      {section.name && (
        <SectionHeader
          title={section.name}
          icon={section.icon}
          path={activeTabPath || section.path}
          shouldNotlazyloadIcon={section.id === 'cinema'}
          ga4Type={section.ga4Type}
          sponseredText={section.sponser?.sponseredText}
          sponseredLogo={section.sponser?.sponseredLogo}
          sponseredLink={section.sponser?.sponseredLink}
          isWapView
          ish1={section.ish1}
        />
      )}
      {Array.isArray(section.subSections) && (
        <div className={`${s.mobileTabsWrap} ${s.fullWidthCover}`}>
          <EtimesMobileTabs
            tabs={section.subSections}
            onChangeCallback={loadSectionData}
            // ga={ga}
            typeShemaClassNames="m_1"
            ga4Type={section.ga4Type}
            s={s}
          />
        </div>
      )}

      {itemstoRender &&
        Array.isArray(itemstoRender) &&
        itemstoRender.length > 0 &&
        itemstoRender.map((sectionItem, sectionIndex) => {
          switch (sectionItem.tn) {
            case 'list_view':
              return (
                <div
                  className={
                    sectionItem.classNames &&
                    Array.isArray(sectionItem.classNames) &&
                    sectionItem.classNames.map(i => s[i]).join(' ')
                  }
                >
                  {sectionItem.items &&
                    Array.isArray(sectionItem.items) &&
                    sectionItem.items.length > 0 &&
                    // eslint-disable-next-line consistent-return, array-callback-return
                    sectionItem.items.map((sectionItemInner, index) => {
                      if (sectionItem.tn === 'row') {
                        return (
                          <div className={`${s.list_item}`}>
                            {renderStoryCard(
                              sectionItemInner,
                              section.ga4Type,
                              section &&
                                section.id === 'featured' &&
                                sectionIndex === 0 &&
                                index === 0,
                              hoveredSlikeId,
                              hoveredSlikeIndex,
                              setSlikePreviewId,
                            )}
                          </div>
                        );
                      } else if (sectionItem.tn === 'list_view') {
                        return (
                          <div
                            className={`${s.listView} ${
                              sectionItemInner.cardType === 'card_12'
                                ? s.lineShift
                                : ''
                            } ${
                              sectionItemInner.cardType === 'card_15'
                                ? s.firstStory
                                : ''
                            }`}
                          >
                            {renderStoryCard(
                              sectionItemInner,
                              section.ga4Type,
                              null,
                              hoveredSlikeId,
                              hoveredSlikeIndex,
                              setSlikePreviewId,
                              // section &&
                              //   section.id === 'featured' &&
                              //   index === 0,
                            )}
                          </div>
                        );
                      }
                    })}
                </div>
              );
            case 'row':
              return (
                <div
                  className={
                    sectionItem.classNames &&
                    Array.isArray(sectionItem.classNames) &&
                    sectionItem.classNames.map(i => s[i]).join(' ')
                  }
                >
                  {sectionItem.items &&
                    Array.isArray(sectionItem.items) &&
                    sectionItem.items.length > 0 &&
                    // eslint-disable-next-line consistent-return, array-callback-return
                    sectionItem.items.map((sectionItemInner, index) => {
                      if (sectionItem.tn === 'row') {
                        return renderStoryCard(
                          sectionItemInner,
                          section.ga4Type,
                          section &&
                            section.id === 'featured' &&
                            sectionIndex === 0 &&
                            index === 0,
                          hoveredSlikeId,
                          hoveredSlikeIndex,
                          setSlikePreviewId,
                          section.toiVideoFeedFormat,
                          section.cardType,
                        );
                      } else if (sectionItem.tn === 'list_view') {
                        return (
                          <div
                            className={`${s.listView} ${
                              sectionItemInner.cardType === 'card_12'
                                ? s.lineShift
                                : ''
                            }`}
                          >
                            {renderStoryCard(
                              sectionItemInner,
                              section.ga4Type,
                              null,
                              // section &&
                              //   section.id === 'featured' &&
                              //   index === 0,
                              hoveredSlikeId,
                              hoveredSlikeIndex,
                              setSlikePreviewId,
                            )}
                          </div>
                        );
                      }
                    })}
                </div>
              );
            case 'carousel':
              return (
                <div
                  className={`slick_UI dark_theme ${
                    section?.notFullWidthCover ? '' : s.fullWidthCover
                  } ${sectionItem.classNames &&
                    Array.isArray(sectionItem.classNames) &&
                    sectionItem.classNames.map(i => s[i]).join(' ')}`}
                >
                  <Slider
                    {...{
                      ...settings,
                      centerMode: section.centerMode,
                      className: section.className,
                    }}
                  >
                    {sectionItem.items &&
                      Array.isArray(sectionItem.items) &&
                      sectionItem.items.length > 0 &&
                      sectionItem.items.map(
                        (sectionItemInner, index) =>
                          section?.bannerPl && sectionItemInner?.hl ? (
                            <NewStoryCard
                              msid={sectionItemInner?.hl}
                              wu={sectionItemInner?.wu}
                            />
                          ) : (
                            renderStoryCard(
                              sectionItemInner,
                              section.ga4Type,
                              section &&
                                section.id === 'featured' &&
                                index === 0,
                              hoveredSlikeId,
                              hoveredSlikeIndex,
                              setSlikePreviewId,
                            )
                          ),
                      )}
                  </Slider>
                </div>
              );
            default:
              return null;
          }
        })}
      {pagination?.paginationtype &&
      pagination?.paginationtype === 'number' &&
      pagination?.nextPageUrl &&
      pagination?.nextPageUrl !== '' ? (
        <>
          <PaginationWidget
            currentPage={1}
            location={pagination?.path}
            totalStories={pagination?.totalRecords}
            storiesPerPage={pagination?.perpage}
          />
        </>
      ) : (
        pagination?.paginationtype !== 'number' && (
          <>
            {(activeTabPath || section.path) &&
              !section.noBtn && (
                <div className={s.seeAllBtn}>
                  <Morebtn
                    absoluteMoreText="See All"
                    moreLink={activeTabPath || section.path}
                    ga4Type={section.ga4Type}
                    ga4Category="cta_click"
                    gaLabel="see_all"
                  />
                </div>
              )}
            {!(activeTabPath || section.path) &&
              nextPageUrl && (
                <div className={s.seeAllBtn}>
                  {nextPageUrl && isLoading && <LoaderSpinner />}
                  <Morebtn
                    absoluteMoreText={
                      section?.loadMoreText || 'Load More Stories'
                    }
                    isNoLink
                    onClick={() => {
                      loadMoreData(nextPageUrl);
                    }}
                    ga4Type={section.ga4Type}
                    ga4Category="cta_click"
                    gaLabel="see_all"
                  />
                </div>
              )}
            {showLoadMoreStories &&
              loadMoreCallback && (
                <div className={s.seeAllBtn}>
                  {showLoadMoreStories && isLoading && <LoaderSpinner />}
                  <Morebtn
                    absoluteMoreText={loadMoreText || 'Load More Stories'}
                    isNoLink
                    onClick={loadMoreCallback}
                  />
                </div>
              )}
          </>
        )
      )}
    </>
  );
};

const mapStateToProps = state => ({
  hoveredSlikeId: state?.common?.slikePreview?.slikeId,
  hoveredSlikeIndex: state?.common?.slikePreview?.index,
});

const mapDispatchToProps = dispatch => ({
  setSlikePreviewId: (slikeId, index) => {
    dispatch(setSlikePreviewID(slikeId, index));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileCardLayout);
